export default "__VITE_ASSET__DUaQ7J8n__"